import { render, staticRenderFns } from "./PretradingTab.vue?vue&type=template&id=e60afe64&scoped=true&"
import script from "./PretradingTab.vue?vue&type=script&lang=js&"
export * from "./PretradingTab.vue?vue&type=script&lang=js&"
import style0 from "./PretradingTab.vue?vue&type=style&index=0&id=e60afe64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60afe64",
  null
  
)

export default component.exports